async function injectProductReviews(productId) {
  const BASE_URL = 'https://dashboard.webwinkelkeur.nl/api/1.0/product_reviews.json';
  const ID = '1210880';
  const CODE = '42a18506c4f8e618f06110407a4ec4c5cef96be220615c4416c99b43a50f3c76';

  try {
    // ── 1. Fetch reviews ───────────────────────────────────────────────────
    const url = `${BASE_URL}?id=${ID}&public_code=${CODE}&limit=1200&product_id=${productId}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    const allReviews = data.product_reviews;

    console.log("allReviews00wproductReviews0", allReviews);
    
    // ── 2. Filter reviews for this specific product ────────────────────────
    const productReviews = allReviews.filter(
      (r) => r.product_id === String(productId) && !r.deleted
    );
    
    console.log("allReviews00wproductReviews0", productReviews);
    
    if (productReviews.length === 0) return;
    
    // ── 3. Calculate aggregate rating ─────────────────────────────────────
    const ratingSum = productReviews.reduce((sum, r) => sum + r.rating, 0);
    const ratingAvg = (ratingSum / productReviews.length).toFixed(1);
    
    // ── 4. Build schema.org Review array ──────────────────────────────────
    const reviewSchema = productReviews.map((r) => ({
      '@type': 'Review',
      '@id': `#review-${r.id}`,
      'reviewRating': {
        '@type': 'Rating',
        'ratingValue': r.rating,
        'bestRating': 5,
        'worstRating': 1,
      },
      'author': {
        '@type': 'Person',
        'name': r.reviewer.name,
      },
      'reviewBody': r.review,
      'datePublished': r.created.split(' ')[0],
      'inLanguage': r.language,
    }));

    // ── 5. Build aggregateRating block ─────────────────────────────────────
    const aggregateRatingSchema = {
      '@type': 'AggregateRating',
      'ratingValue': parseFloat(ratingAvg),
      'reviewCount': productReviews.length,
      'bestRating': 5,
      'worstRating': 1,
    };

    // ── 6. Find existing JSON-LD script and inject ─────────────────────────
    // Using backticks for dynamic string interpolation to avoid Liquid tags
    const scriptTag = document.querySelector(`script#product-schema-${productId}`);
    if (!scriptTag) return;

    const schema = JSON.parse(scriptTag.textContent);
    schema.aggregateRating = aggregateRatingSchema;
    schema.review = reviewSchema;

    scriptTag.textContent = JSON.stringify(schema, null, 2);

    console.log("productReviews000", productReviews, scriptTag, schema);
    console.log(`✅ Injected ${productReviews.length} reviews for product ${productId}`);

  } catch (error) {
    console.error('Failed to inject product reviews:', error);
  }
}

// ── Call with Shopify product ID from the DOM element ──────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const main_element = document.querySelector('[data-google-product-schema]'); 
  
  if (main_element) {
    // Get the product ID using the data-product-id attribute
    const productId = main_element.getAttribute('data-product-id');
    
    if (productId) {
      injectProductReviews(productId);
    } else {
      console.warn('The data-product-id attribute was not found on the [data-google-product-schema] element.');
    }
  }
});